import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import Layout from "../components/layout"
import { HeadingThree } from "../elements"
import { ContentWrapper } from "../pages/news-and-updates"
import PostLatest from "../components/postLatest"
import PostFBFeed from "../components/postFbFeed"

const Tag = ({ data, pageContext }) => {
  const posts = data.allPrismicPost.edges
  const { tag } = pageContext

  return (
    <Layout>
      <ContentWrapper>
        <TagContainer>
          <HeadingThree fontSize="15px" margin="0 0 18px 0">
            Filtered by tag: {tag}
          </HeadingThree>
          {posts.map((post, i) => (
            <PostLatest key={i} post={post.node} />
          ))}
        </TagContainer>
        <PostFBFeed />
      </ContentWrapper>
    </Layout>
  )
}

export default Tag

const TagContainer = styled.section`
  min-height: 100vh;
`

export const query = graphql`
  query($tag: String) {
    allPrismicPost(filter: { tags: { eq: $tag } }) {
      edges {
        node {
          tags
          slugs
          first_publication_date
          data {
            title {
              text
            }
            release_date
            description {
              html
            }
            featured_image {
              url
              localFile {
                childImageSharp {
                  fluid(quality: 90) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            source {
              text
            }
          }
        }
      }
    }
  }
`
